module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_common_warning.32e20aaa.gif";